import { reduxForm, formValueSelector } from 'redux-form'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withStyles } from '@material-ui/core';

import { AddWaitingPassengerForm as View } from "./AddWaitingPassengerForm";

import { routeActions } from 'reduxModules/actions/RouteActions';
import { routeCitiesSelector } from 'reduxModules/selectors/CitySelectors'
import { isWaitingPassengersLoadingSelector } from 'reduxModules/selectors/RouteSelectors'

import { styles } from './styles'

const addWaitingPassengerFormSelector = formValueSelector('AddWaitingPassenger')

const mapStateToProps = (state, props) => ({
  to: addWaitingPassengerFormSelector(state, 'to'),
  from: addWaitingPassengerFormSelector(state, 'from'),
  routeCities: routeCitiesSelector(state, props),
  isLoading: isWaitingPassengersLoadingSelector(state, props)
})

const mapDispatchToProps = {
  setWaitingPassenger: routeActions.setWaitingPassenger,
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({
    form: 'AddWaitingPassenger',
  }),
  withStyles(styles),
)

export const AddWaitingPassengerForm = enhance(View)


// WEBPACK FOOTER //
// ./src/components/AddWaitingPassengerForm/index.js